import _isEmpty from 'lodash/isEmpty';
import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.problems, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_PROBLEMS}_SUCCESS`: {
      let temp = [];
      if (_isEmpty(state.cached))
        temp = [
          { problems: action.payload, keys: action.payload.map(p => p.slug) },
        ];
      else {
        temp = JSON.parse(JSON.stringify(state.cached));
        temp.push({
          problems: action.payload,
          keys: action.payload.map(p => p.slug),
        });
      }
      return _assign({}, state, { cached: temp });
    }
    case `${ActionTypes.SET_PROBLEMS_GROUP}_SUCCESS`: {
      return _assign({}, state, { sectionsGrouped: action.payload });
    }
    case ActionTypes.INDEX_PROBLEMS: {
      return {
        ...state,
        indexedProblems: action.payload.indexedProblems,
      };
    }
    case ActionTypes.SLUG_CHANGE_FROM_ROUTER: {
      return {
        ...state,
        slugChangeFromRouter: action.slugChangeFromRouter,
      };
    }
    default:
      return state;
  }
};
